export default [
  {
    id: '0dcffb69-1bda-4425-b17d-c70ff28abd0b',
    path: '/layout',
    name: 'layout',
    meta: {
      title: '门户布局',
      hidden: true,
    },
    layout: 'fullscreen',
    children: [
      {
        id: '6aade248-5569-4b55-8276-baecf2fe3554',
        path: 'layout-config',
        name: 'layoutConfig',
        component: () => {
          return import('./views/portal-config/LayoutConfig')
        },
        meta: {
          title: '门户布局配置',
        },
      },
    ],
  },
  {
    id: '575612a7-41a4-40f9-ba02-aa45528c9c0f',
    path: '/portal-management',
    name: 'portalManagement',
    meta: {
      title: '门户管理',
    },
    children: [
      {
        id: '7db1e003-2e92-4d3e-bb54-1cf21b2db2c8',
        path: 'portal-config',
        name: 'portalConfig',
        meta: {
          title: '门户设置',
        },
        children: [
          {
            id: '387e8f02-0d40-4f27-8d18-99ec2b191694',
            path: 'layout-management',
            name: 'layoutManagement',
            component: () => {
              return import('./views/portal-config/LayoutManagement')
            },
            meta: {
              title: '门户布局管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                read: {
                  id: 2,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '551a220a-9636-4952-a2a5-18ff47557c47',
            path: 'app-layout-management',
            name: 'appLayoutManagement',
            component: () => {
              return import('./views/portal-config/LayoutManagement')
            },
            meta: {
              title: 'APP布局管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                read: {
                  id: 2,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'b3fc3a93-7c54-446c-94a5-07076d91587a',
            path: 'portal-column-management',
            name: 'portalColumnManagement',
            component: () => {
              return import('./views/portal-config/PortalColumnManagement')
            },
            meta: {
              title: '门户栏目管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f0eb2350-8776-48ab-929a-02a8d52e86ed',
            path: 'component-management',
            name: 'componentManagement',
            component: () => {
              return import('./views/portal-config/ComponentManagement')
            },
            meta: {
              title: '门户组件管理',
            },
          },
          {
            id: '433c9b58-e320-43ca-82db-600073f9b8cc',
            path: 'workbench-config',
            name: 'WorkbenchConfig',
            component: () => {
              return import('./views/portal-config/WorkbenchConfig')
            },
            meta: {
              title: '工作台设置',
              operations: {
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f6d3fb46-0cba-4fac-8bb6-29b71c2de1de',
            path: 'navigation-config',
            name: 'navigationConfig',
            component: () => {
              return import('./views/portal-config/NavigationConfig')
            },
            meta: {
              title: '导航栏设置',
              operations: {
                update: {
                  id: 0,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
              },
            },
          },
          {
            id: '75bf3abe-dc3a-4864-8b79-271c8ae4fe2c',
            path: 'column-detail-config',
            name: 'columnDetailConfig',
            component: () => {
              return import('./views/portal-config/ColumnDetailConfig')
            },
            meta: {
              title: '详情页设置',
              operations: {
                update: {
                  id: 0,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '58da29f4-94e4-42bb-af39-be523a7567b7',
        path: 'information-publish',
        name: 'informationPublish',
        meta: {
          title: '信息发布',
        },
        children: [
          {
            id: '6f3edf03-f7d0-4fee-b17d-2393abc448f9',
            path: 'column-publish-application',
            name: 'columnPublishApplication',
            component: () => {
              return import('./views/information-publish/ColumnPublishManagement')
            },
            meta: {
              title: '栏目发布申请',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                submit: {
                  id: 4,
                  name: 'submit',
                  desc: '提交',
                  access: true,
                },
                audit: {
                  id: 5,
                  name: 'audit',
                  desc: '审批',
                  access: true,
                },
                readFlow: {
                  id: 6,
                  name: 'readFlow',
                  desc: '查看流程',
                  access: true,
                },
                withdraw: {
                  id: 7,
                  name: 'withdraw',
                  desc: '撤回',
                  access: true,
                },
              },
            },
          },
          {
            id: '26b3a30c-10c1-4c93-a544-940b481bf0b9',
            path: 'column-publish-information',
            name: 'columnPublishInformation',
            component: () => {
              return import('./views/information-publish/ColumnPublishManagement/Information')
            },
            meta: {
              title: '栏目发布信息',
              operations: {
                read: {
                  id: 0,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                export: {
                  id: 1,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f09d8be4-340f-43ac-b9c3-2a77992f4fac',
            path: 'column-publish-detail',
            name: 'columnPublishDetail',
            component: () => {
              return import('./views/information-publish/ColumnPublishManagement/Detail')
            },
            meta: {
              title: '栏目发布详情',
              hidden: true,
              tabnab: false,
              activeMenu: '/portal-management/information-publish/column-publish-application',
            },
          },
          {
            id: '1954cae6-fabf-4572-be48-397ea85b994f',
            path: 'component-publish-management',
            name: 'componentPublishManagement',
            component: () => {
              return import('./views/information-publish/ComponentPublishManagement')
            },
            meta: {
              title: '组件发布管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '91c16ed1-4866-476c-ba81-63ba395d73c4',
            path: 'column-statistics-management',
            name: 'columnStatisticsManagement',
            component(resolve) {
              require(['./views/information-publish/ColumnStatisticsManagement'], resolve)
            },
            meta: {
              title: '栏目统计管理',
              operations: {},
            },
          },
          {
            id: '1af25c44-eac0-4968-b0ed-1a4d966a98d7',
            path: 'publish-statistics',
            name: 'publishStatistics',
            component(resolve) {
              require(['./views/information-publish/ColumnStatisticsManagement/PublishStatistics'], resolve)
            },
            meta: {
              title: '栏目发布统计',
              operations: {
                read: {
                  id: 0,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                export: {
                  id: 1,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
              },
            },
          },
          {
            id: 'e0dc3a39-057a-4375-aafa-84060a248e6b',
            path: 'publishing-material-management',
            name: 'publishingMaterialManagement',
            component(resolve) {
              require(['./views/information-publish/PublishingMaterialManagement'], resolve)
            },
            meta: {
              title: '发布素材管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                goToPublish: {
                  id: 4,
                  name: 'goToPublish',
                  desc: '前往发布',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: 'a04a58d8-47f3-4cdb-9b52-4922d8300d3e',
        name: 'gatherManagement',
        path: 'gather-management',
        meta: {
          title: '采集管理',
        },
        children: [
          {
            id: 'bb17eeb5-17e5-4971-861f-4b60c5afa29f',
            path: 'gather-tasks-management',
            name: 'gatherTasksManagement',
            component: () => {
              return import('./views/gather-management/GatherTasksManagement')
            },
            meta: {
              title: '采集任务管理',
              operations: {
                update: {
                  id: 0,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                create: {
                  id: 2,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                import: {
                  id: 4,
                  name: 'import',
                  desc: '导入',
                  access: true,
                },
                enable: {
                  id: 5,
                  name: 'enable',
                  desc: '启用',
                  access: true,
                },
                deactivate: {
                  id: 6,
                  name: 'deactivate',
                  desc: '停用',
                  access: true,
                },
              },
            },
          },
          {
            id: 'a247cf9a-7645-4cd9-ad0a-8098282996d8',
            path: 'collection-records',
            name: 'collectionRecords',
            meta: {
              title: '采集记录管理',
              operations: {
                catalogueCreate: {
                  id: 1,
                  name: 'catalogueCreate',
                  desc: '新增',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/gather-management/CollectionRecords')
            },
          },
        ],
      },
      {
        id: 'f80b8f6c-f001-4ed0-b69d-3e2bc2359be4',
        path: 'system-management',
        name: 'systemManagement',
        meta: {
          title: '系统管理',
        },
        children: [
          {
            id: 'fa0091aa-2722-4171-8471-56fc301b7032',
            path: 'system-config',
            name: 'systemConfig',
            component: () => {
              return import('./views/system-management/SystemConfig')
            },
            meta: {
              title: '系统设置',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                // import: {
                //   id: 4,
                //   name: 'import',
                //   desc: '导入',
                //   access: true,
                // },
              },
            },
          },
          {
            id: '2ecb3213-b9b0-4d3d-89e9-33c6ff6be638',
            path: 'system-config-detail',
            name: 'systemConfigDetail',
            component: () => {
              return import('./views/system-management/SystemConfigDetail')
            },
            meta: {
              title: '系统设置详情',
              hidden: true,
              activeMenu: '/portal-management/system-management/system-config',
            },
          },
          {
            id: '3057bbb5-12a2-4e31-9e63-617c5009f00d',
            path: 'sensitive-word-management',
            name: 'sensitiveWordManagement',
            component: () => {
              return import('./views/system-management/SensitiveWordManagement')
            },
            meta: {
              title: '敏感词管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                import: {
                  id: 3,
                  name: 'import',
                  desc: '导入',
                  access: true,
                },
              },
            },
          },
          {
            id: 'fc275117-0785-4fc7-bc89-65d3eae786d1',
            path: 'app-management',
            name: 'appManagement',
            component: () => {
              return import('./views/system-management/AppManagement')
            },
            meta: {
              title: '应用系统管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: false,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: false,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: false,
                },
              },
            },
          },
          {
            id: '43764016-d9e9-4a5c-809d-21689f3e3ad2',
            path: 'app-config',
            name: 'appConfig',
            component: () => {
              return import('./views/system-management/AppConfig')
            },
            meta: {
              title: '应用系统管理详情',
              hidden: true,
              activeMenu: '/portal-management/system-management/app-management',
            },
          },
          {
            id: '27f016a2-775c-4085-bb70-38c0d890a2a2',
            path: 'publish-permissions',
            name: 'publishPermissions',
            meta: {
              title: '发布权限管理',
              operations: {
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/gather-management/PublishPermissions')
            },
          },
          {
            id: '89656b08-8c14-4301-a0a3-a42fe827d43b',
            path: 'sso-management',
            name: 'ssoManagement',
            component: () => {
              return import('./views/system-management/SSOManagement')
            },
            meta: {
              title: '单点登录管理',
              operations: {
                read: {
                  id: 0,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '3dba7d2b-20f4-4177-bad5-db1659db0480',
        path: 'royalties-management',
        name: 'royaltiesManagement',
        meta: {
          title: '稿件稿费管理',
        },
        children: [
          {
            id: '02503de1-df75-4051-befd-2d9e7f9fbb18',
            path: 'column-royalties-management',
            name: 'columnRoyaltiesManagement',
            meta: {
              title: '栏目稿费管理',
              operations: {
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/royalties-management/ColumnRoyaltiesManagement')
            },
          },
          {
            id: '695167e6-41ac-4cf8-9bcd-b97f702c69c5',
            path: 'royalties-standard-management',
            name: 'royaltiesStandardManagement',
            meta: {
              title: '稿费标准管理',
              operations: {
                edit: {
                  id: 1,
                  name: 'edit',
                  desc: '编辑',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/royalties-management/RoyaltiesStandard')
            },
          },
          {
            id: '13675d63-9ba6-4ede-8b0b-cfdec4ca3489',
            path: 'royalties-compute',
            name: 'royaltiesCompute',
            meta: {
              title: '稿费计算管理',
              operations: {
                export: {
                  id: 1,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/royalties-management/RoyaltiesCompute')
            },
          },
          {
            id: 'b0784de1-39e4-48f8-ba40-4480d01444b8',
            path: 'royalties-compute-management',
            name: 'royaltiesComputeManagement',
            component(resolve) {
              require(['./views/royalties-management/RoyaltiesComputeManagement'], resolve)
            },
            meta: {
              title: '稿费计算信息',
              hidden: true,
              tabnab: false,
              activeMenu: '/portal-management/royalties-management/royalties-compute',
            },
          },
          {
            id: '2be8a10e-b7e2-4d38-abba-792270fcabe8',
            path: 'person-royalties-management',
            name: 'personRoyaltiesManagement',
            meta: {
              title: '人员稿费清单',
              operations: {
                export: {
                  id: 1,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/royalties-management/PersonRoyalties')
            },
          },
          {
            id: '6681d9da-a834-485d-9e46-38ac54361868',
            path: 'promote-monthly-goals',
            name: 'promoteMonthlyGoals',
            meta: {
              title: '宣传月度目标',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/royalties-management/PromoteMonthlyGoals')
            },
          },
          {
            id: '1a983f6f-320d-4cef-aff0-cc7088c99db5',
            path: 'promote-monthly-goals-detail',
            name: 'promoteMonthlyGoalsDetail',
            meta: {
              title: '宣传月度目标详情',
              hidden: true,
              tabnab: false,
              activeMenu: 'promote-monthly-goals',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                delete: {
                  id: 1,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                read: {
                  id: 2,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/royalties-management/PromoteMonthlyGoalsDetail')
            },
          },
          {
            id: 'eb1ae149-e4d7-4fa2-b74c-0b77503e42f7',
            path: 'propaganda-monthly-statistics',
            name: 'propagandaMonthlyStatistics',
            meta: {
              title: '宣传月度统计',
              operations: {
                read: {
                  id: 0,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                export: {
                  id: 2,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
              },
            },
            component: () => {
              return import('./views/royalties-management/propagandaMonthlyStatistics')
            },
          },
          {
            id: 'c04d5d00-41d5-42d0-a5a1-a44eae3451d0',
            path: 'propaganda-monthly-statistics-detail',
            name: 'propagandaMonthlyStatisticsDetail',
            meta: {
              title: '宣传月度统计详情',
              hidden: true,
              tabnab: false,
              activeMenu: 'propaganda-monthly-statistics',
            },
            component: () => {
              return import('./views/royalties-management/propagandaMonthlyStatisticsDetail')
            },
          },
        ],
      },
      {
        id: '340bc8e9-5128-4ad1-8625-47bd943abad2',
        path: 'person-agency',
        name: 'personAgency',
        meta: {
          title: '个人待办',
          operations: {
            read: {
              id: 0,
              name: 'read',
              desc: '查看',
              access: true,
            },
            audit: {
              id: 1,
              name: 'audit',
              desc: '处理',
              access: true,
            },
            readFlow: {
              id: 2,
              name: 'readFlow',
              desc: '查看流程',
              access: true,
            },
          },
        },
        component: () => {
          return import('./views/person-agency/PersonAgency')
        },
      },
    ],
  },
]
